import { hasValue } from "@advosys/component-react-utils";
export const formatUserDisplayValue = (user) => (hasValue(user) ? `${user.id} - ${user.name}` : undefined);
